import React, { useEffect, useState } from "react";
import CustomerInformationInputType from "../constants/customer-information-input-type";
import StoreAction from "../constants/store-action";
import { validatePersonalNumber } from "../utils/validation";
import { createCustomerObject } from "../tools/data-creator";
import { validateCustomerObjectPersonalNumber } from "../tools/data-validation";
import Alert from "../components/alert";
import Spinner from "../components/spinner";
import { handleEnterPress } from "../utils/events";
export default (props) => {
    const [hasRequestError, setHasRequestError] = useState(false);
    useEffect(() => {
        const insurance = props.data.insurance;
        const customer = props.data.customer;
        const shouldUpdateCustomerPersonalNumber = insurance.personalNumber && customer.personalNumber === null;
        if (shouldUpdateCustomerPersonalNumber) {
            props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
                type: "customer",
                name: "personalNumber",
                value: insurance.personalNumber,
            });
        }
    });
    const handleInputChange = (e) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "customer",
            name: e.target.name,
            value: e.target.value,
        });
    };
    const handleBlur = (e) => {
        props.dispatchStoreAction(StoreAction.INTERACT_UPDATE_SPECIFIC, {
            type: "customer",
            name: e.target.name,
        });
    };
    const handleKeyPress = (e) => handleEnterPress(e, () => handleInputTypeClick(CustomerInformationInputType.AUTOMATIC));
    const onFetchInfoClick = () => handleInputTypeClick(CustomerInformationInputType.AUTOMATIC);
    const onInputInfoClick = () => handleInputTypeClick(CustomerInformationInputType.MANUAL);
    const handleProceedWithAutomaticLookup = (state) => {
        const customerObject = createCustomerObject(state.customer, null);
        const isValidPersonalNumber = validateCustomerObjectPersonalNumber(customerObject);
        if (!isValidPersonalNumber) {
            return props.dispatchStoreAction(StoreAction.INTERACT_UPDATE_SPECIFIC, { type: "customer", name: "personalNumber" });
        }
        setHasRequestError(false);
        props.onFetchAddressInformation((isSuccessful) => {
            if (isSuccessful) {
                props.onProceedToNextStep();
            }
            else {
                setHasRequestError(true);
            }
        });
    };
    const handleInputTypeClick = (inputType) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "customer",
            name: "inputType",
            value: inputType,
        }, (state) => {
            const isAutomatic = inputType === CustomerInformationInputType.AUTOMATIC;
            if (isAutomatic) {
                handleProceedWithAutomaticLookup(state);
            }
            else {
                props.onProceedToNextStep();
            }
        });
    };
    const hasPersonalNumberError = props.data.interact.customer.personalNumber &&
        !validatePersonalNumber(props.data.customer.personalNumber);
    return (React.createElement("div", { "data-ecom-page": "" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Kunduppgifter"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "H\u00E4mta dina uppgifter via personnummer eller skriv in dem manuellt."))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-form": "" },
                React.createElement("div", { className: `form-group ${hasPersonalNumberError ? " has-error" : ""}` },
                    React.createElement("label", { "data-ecom-inputlabel": "", htmlFor: "information-1-input-personalnr" }, "Personnummer"),
                    React.createElement("div", { "data-ecom-inputtext": "" },
                        React.createElement("input", { type: "text", id: "information-1-input-personalnr", name: "personalNumber", placeholder: "\u00C5\u00C5\u00C5\u00C5MMDD-XXXX", value: props.data.customer.personalNumber || "", onChange: handleInputChange, onBlur: handleBlur, onKeyPress: handleKeyPress })),
                    React.createElement("div", { className: "form-alert" }, "Ange personnummer i formatet \u00C5\u00C5\u00C5\u00C5MMDD-XXXX")),
                hasRequestError && (React.createElement("div", { className: "form-group" },
                    React.createElement(Alert, { message: `Tyvärr fick vi ingen träff på personnumret du angav.` }))),
                !props.isWaitingForResponse && (React.createElement("div", { className: "form-group" },
                    React.createElement("button", { "data-ecom-button": "full-width", onClick: onFetchInfoClick }, "H\u00E4mta uppgifter"))),
                props.isWaitingForResponse && (React.createElement("div", { className: "form-group" },
                    React.createElement(Spinner, null)))),
            React.createElement("div", { className: "m-t" },
                React.createElement("button", { "data-ecom-button": "full-width light", onClick: onInputInfoClick }, "Fyll i manuellt")))));
};
